const ZAPIER_HOOK_CONTACTUS = process.env.VUE_APP_CONTACTUS_ZAPIER_API;

export default {
  ZAPIER_HOOK_CONTACTUS,
};

export {
  ZAPIER_HOOK_CONTACTUS
};
